module.exports = __webpack_public_path__ + "fonts/poppins-bold-devanagari.84b9421.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/poppins/poppins-bold-devanagari.woff2
// module id = 590
// module chunks = 0